<template>
  <el-form ref="dataForm" :model="productState" label-position="top" status-icon>
    <div v-if="!hideInfo" class="row ml-0 mr-0">
      <!-- <div class="col col-lg-7">
        <template v-if="!isEditable">
          <h2 class="row">{{ productState.name }}</h2>
        </template>
        <template v-else>
          <el-form-item
            prop="name"
            required
            class="form-text text-white"
            :rules="{
              required: true,
              message: $t('error.vuelidate.required'),
              trigger: 'blur',
            }"
          >
            <el-input v-model="productState.name" placeholder="Title" type="text" :disabled="isUpdating" @blur="updateProduct" />
          </el-form-item>
        </template>

          <p v-if="!isEditable" id="product-details-info-text" class="row form-text text-white">
          <span class="d-block mb-3">
            {{ productState.description }}
          </span>

          <button
            v-if="videoMetadata?.productId === product.productId.toString()"
            type="button"
            class="btn btn-warning d-flex"
            @click="handleShowVideo(videoMetadata)"
          >
            Watch Video
          </button>
        </p>

        <el-form-item
          v-else
          prop="description"
          required
          class="form-text text-white"
          :rules="{
            required: true,
            message: $t('error.vuelidate.required'),
            trigger: 'blur',
          }"
        >
          <el-input v-model="productState.description" placeholder="Description" :rows="4" type="textarea" :disabled="isUpdating" @blur="updateProduct" />
        </el-form-item>
      </div> -->
      <div class="col col-lg-1">
        <el-icon v-if="isAuthenticated && !isEditable" @click="toggleEditable">
          <font-awesome-icon icon="edit" />
        </el-icon>
        <!--<el-icon @click="toggleEditable" v-else>
            <font-awesome-icon icon="edit" />
          </el-icon>-->
      </div>
      <div class="col col-lg-5 d-flex justify-content-center">
        <slot></slot>
      </div>
    </div>
  </el-form>

  <div class="row">
    <product-parameter-cover
      v-if="type_mapper.isProductType(product, ProductType.covers)"
      :order="order"
      :product="product"
      :readonly="readonly"
      @zip-changed="(zip: any) => $emit('zipChanged', zip)"
      @info-button-clicked="showMeasurementInfoModalDialog"
      @scan-file-changed="selected"
      ref="activeProductForm"
      @is-valid="updateValidation"
    />
    <product-parameter-brace
      v-if="type_mapper.isProductType(product, ProductType.brace)"
      :order="order"
      :product="product"
      :readonly="readonly"
      @zip-changed="(zip: any) => $emit('zipChanged', zip)"
      @info-button-clicked="showMeasurementInfoModalDialog"
      @scan-file-changed="selected"
      ref="activeProductForm"
      @is-valid="updateValidation"
    />
    <!-- TODOS: ADJUST IF PROPS -->
    <product-parameter-template
      v-if="product.name.replace(/\s/g, '').toLowerCase().includes('phase1')"
      :key="product.productId"
      :properties="order"
      :product="product"
      :readonly="readonly"
      @info-button-clicked="showProductParameterTemplateInfoDialog"
      @update-properties="(newProperties: any) => $emit('updateProperties', newProperties)"
    />
    <!-- TODOS: ADJUST IF PROPS -->
    <product-parameter-orthesis
      v-if="product.type.name.toLowerCase() == 'orthesen' && !product.name.replace(/\s/g, '').toLowerCase().includes('phase1')"
      :order="order"
      :product="product"
      :readonly="readonly"
      @zip-changed="(zip: any) => $emit('zipChanged', zip)"
      @scan-file-changed="selected"
    />
    <!--<product-parameter-cuboid
      v-if="product.type.name.toLowerCase() == 'möbel' ||
            product.type.name.toLowerCase() == 'sonstige' ||
            product.type.name.toLowerCase() == 'hütten'"
      :properties="order"
    />
    -->
    <product-parameter-balcony v-if="product.type.name.toLowerCase() == 'balkone'" :order="this.order" />
    <product-parameter-fence
      v-if="product.type.name.toLowerCase() == 'fence'"
      :order="order"
    />
    <!-- <product-parameter-fence
      v-if="product.type.name.toLowerCase() == 'zäune'"
      :properties="order"
      :readonly="readonly"
      :product="product.type.name.toLowerCase()"
    /> -->
    <product-parameter-linear-light
      v-if="product.type.name.toLowerCase() == 'lineare beleuchtung'"
      :properties="order"
      :is-hanging-light="product.name.toLowerCase() === LinearLightNameType.hanging.toLowerCase()"
      :is-surface-mounted-light="product.name.toLowerCase() === LinearLightNameType.surfaceMounted.toLowerCase()"
      :readonly="readonly"
    />
    <product-parameter-bathtub v-if="product.type.name.toLowerCase() == 'duschen und bäder'" :properties="order" :readonly="readonly" />

    <div id="measurement-info" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- HEADER with fixed close button -->
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <!-- BODY is scrollable -->
          <div class="modal-body">
            <measurement-info-card>
              <div class="row">
                <div v-if="selectedContent == 'content1'" class="col-12">
                  <p class="subtitle text-black">{{ $t('components.order-form.scope-top') }}</p>
                  <div class="row">
                    <div class="txtcol col-12 col-lg-7">
                      <p class="form-text text-black">
                        {{ $t('components.product-parameter.measurementsInfo.scope.top.info') }}
                      </p>
                      <ul style="list-style-type: disc; padding-left: 20px">
                        <li class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bullet1') }}
                        </li>
                        <li class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bullet2') }}
                        </li>
                        <li class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bullet3') }}
                        </li>
                        <li class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bullet4') }}
                        </li>
                        <li class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bullet5') }}
                        </li>
                      </ul>
                    </div>
                    <div class="imgcol col-12 col-lg-5">
                      <img class="infoimg" src="@/assets/images/covers/scope_calve.png" />
                    </div>
                  </div>
                </div>
                <div v-if="selectedContent == 'content2'" class="col-12">
                  <p class="subtitle text-black">{{ $t('components.order-form.height') }}</p>
                  <div class="row">
                    <div class="txtcol col-12 col-lg-7">
                      <div v-if="product.name.toLowerCase().includes('unterschenkel')">
                        <p class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.height-leg.upper.info') }}
                        </p>
                        <ul style="list-style-type: disc; padding-left: 20px">
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet1') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet2') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet3') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet4') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet5') }}
                          </li>
                        </ul>
                      </div>
                      <div v-else>
                        <p class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.height-leg.lower.info') }}
                        </p>
                        <ul style="list-style-type: disc; padding-left: 20px">
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet1') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet2') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet3') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet4') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet5') }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="imgcol col-12 col-lg-5">
                      <img
                        v-if="product.name.toLowerCase().includes('unterschenkel')"
                        class="infoimg"
                        src="@/assets/images/covers/height_lower_leg.png"
                      />
                      <img v-else class="infoimg" src="@/assets/images/covers/height_upper_leg.png" />
                    </div>
                  </div>
                </div>
                <div v-if="selectedContent == 'content3'" class="col-12">
                  <p class="subtitle text-black">{{ $t('components.order-form.scope-bottom') }}</p>
                  <div class="row">
                    <div class="txtcol col-12 col-lg-7">
                      <p class="form-text text-black">
                        {{ $t('components.product-parameter.measurementsInfo.scope.bottom.info') }}
                      </p>
                      <ul style="list-style-type: disc; padding-left: 20px">
                        <li class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bullet1') }}
                        </li>
                        <li class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bullet2') }}
                        </li>
                        <li class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bullet3') }}
                        </li>
                        <li class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bullet4') }}
                        </li>
                        <li class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bullet5') }}
                        </li>
                      </ul>
                    </div>
                    <div class="imgcol col-12 col-lg-5">
                      <img class="infoimg" src="@/assets/images/covers/scope_ankle.png" />
                    </div>
                  </div>
                </div>
              </div>
            </measurement-info-card>
          </div>
        </div>
      </div>
    </div>

    <div id="product-parameter-info" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div id="info-content" class="modal-content">
          <div id="info-header" class="modal-header border-bottom-0 bg-transparent">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div id="info-body" class="modal-body p-0">
            <measurement-info-card>
              <div class="row">
                <div v-if="Boolean(selectedContent)" class="col-12 text-center">
                  <img class="infoimg" :src="selectedContent || ''" />
                </div>
              </div>
            </measurement-info-card>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Video preview modal ... -->
  <PreviewRendererDetails ref="previewRendererDetails" :can-download="true" :can-remove="true" />
</template>

<script lang="ts">
import { Vue, Component, Prop, Ref } from 'vue-facing-decorator';
import { Modal } from 'bootstrap';
import { ElForm } from 'element-plus';

import type_mapper from '@/types/api/Utility/TypeMapper';
import { Product } from '@/types/api/Model/Product';
import { ProductType } from '@/types/enum/upload';
import ProductParameterCover from '@/components/productParameters/ProductParameterCover.vue';
import ProductParameterCuboid from '@/components/productParameters/ProductParameterCuboid.vue';
import * as productService from '@/services/api/productService';
import { Body_Attribute } from '@/types/api/Patient/BodyAttribute';
import { LinearLightNameType } from '@/types/enum/order';
import ProductParameterBalcony from '@/components/productParameters/ProductParameterBalcony.vue';
import ProductParameterFence from '@/components/productParameters/ProductParameterFence.vue';
import ProductParameterOrthesis from '@/components/productParameters/ProductParameterOrthesis.vue';
import ProductParameterBrace from '@/components/productParameters/ProductParameterBrace.vue';
import ProductParameterTemplate from '@/components/productParameters/ProductParameterTemplate.vue';
import ProductParameterLinearLight from '@/components/productParameters/ProductParameterLinearLight.vue';
import ProductParameterBathtub from '@/components/productParameters/ProductParameterBathtub.vue';
import MeasurementInfoCard from '@/components/productParameters/MeasurementInfoCard.vue';
import { removeWordFromString } from '@/utils/formBuilder';
import { TableField } from '@/utils/file';
import PreviewRendererDetails from '@/components/features/previewRenderer/PreviewRendererDetails.vue';
import { OrderRequestData } from '@/services/api/orderService';
import { useComponentStatusStore} from '@/stores/componentStatus';
import { getFromLocalStorageOrDefault } from '@/utils/localStorage';


@Component({
  components: {
    MeasurementInfoCard,
    ProductParameterCover,
    ProductParameterCuboid,
    ProductParameterFence,
    ProductParameterOrthesis,
    ProductParameterBrace,
    ProductParameterTemplate,
    ProductParameterLinearLight,
    ProductParameterBathtub,
    ProductParameterBalcony,
    PreviewRendererDetails,
  },
  emits: ['buttonClicked', 'zipChanged', 'infoButtonClicked', 'updateProperties', 'productUpdated', 'isValid'],
})
export default class ProductSettings extends Vue {
  @Prop() product!: Product;
  @Prop() isAuthenticated?: boolean;
  @Prop() order!: OrderRequestData;
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) hideInfo!: boolean;
  @Prop() videoMetadata!: TableField;

  type_mapper = type_mapper;
  ProductType = ProductType;
  selectedBodyAttribute: Body_Attribute | null = null;

  @Ref() readonly activeProductForm!: InstanceType<typeof ProductParameterCover>;

  isFormValid = false;

  updateValidation(valid: boolean) {
    this.isFormValid = valid;
    this.$emit('isValid', valid);
  }

  async validateProductForm(): Promise<boolean> {
    if (!this.activeProductForm) {
      return false;
    }

    const valid = await this.activeProductForm.validateForm();
    this.updateValidation(valid);
    return valid;
  }

  isEditable = false;
  isUpdating = false;
  productState: {
    name: string;
    description: string;
  } = {
    name: '',
    description: '',
  };

  private measurementInfoModalDialog: Modal | null = null;
  private productParameterTemplateDialog: Modal | null = null;
  selectedContent: string | null = null;

  LinearLightNameType = LinearLightNameType;

  mounted(): void {
    const statusStore = useComponentStatusStore();
    statusStore.setMounted(true);
    
    // Set default values of properties    
    switch (this.product.type.name.toLowerCase()) {
      case 'covers':
        this.order.heightWithoutDeduction = getFromLocalStorageOrDefault('heightWithoutDeduction', 330);
        this.order.depth = getFromLocalStorageOrDefault('depth', 265);
        this.order.calfCircumferenceWithoutDeduction = getFromLocalStorageOrDefault('calfCircumferenceWithoutDeduction', 200);
        this.order.bilateralAmputee = false;
        break;
      case 'brace':
        this.order.heightWithoutDeduction = getFromLocalStorageOrDefault('heightWithoutDeduction', 3.5);
        this.order.bilateralAmputee = false;
        break;
      case 'zäune':
        this.order.heightWithoutDeduction = getFromLocalStorageOrDefault('heightWithoutDeduction', 1100);
        break;
      case 'orthesen':
        this.order.heightWithoutDeduction = getFromLocalStorageOrDefault('heightWithoutDeduction', 420);
        this.order.depth = getFromLocalStorageOrDefault('depth', 180);
        this.order.bilateralAmputee = false;
        break;
    }

    // Preload images
    const imagePaths = [
      '@/assets/images/covers/scope_calve.png',
      '@/assets/images/covers/height_upper_leg.png',
      '@/assets/images/covers/scope_ankle.png',
    ];

    imagePaths.forEach((path) => {
      const img = new Image();
      img.src = new URL(path, import.meta.url).href;
    });

    const modalDialogOptions = {};
    this.measurementInfoModalDialog = new Modal('#measurement-info', modalDialogOptions);
    this.productParameterTemplateDialog = new Modal('#product-parameter-info', modalDialogOptions);
    this.productState.name = removeWordFromString(this.product?.name, 'phase1');
    this.productState.description = this.product.description;
  }

  // Truncate 'phase1' word in title string
  get productTitle(): string {
    return removeWordFromString(this.product?.name, 'phase1', 20);
  }

  selected(bodyAttribute: Body_Attribute): void {
    this.selectedBodyAttribute = bodyAttribute as Body_Attribute;
  }

  showMeasurementInfoModalDialog(content: string | null): void {
    this.selectedContent = content;
  
    const modalEl = document.getElementById("measurement-info");
    if (modalEl) {
      document.body.appendChild(modalEl); // Move modal to body
      this.measurementInfoModalDialog?.show();
    }
  }

  showProductParameterTemplateInfoDialog(content: string | null): void {
    this.selectedContent = content;
  
    const modalEl = document.getElementById("measurement-info");
    if (modalEl) {
      document.body.appendChild(modalEl); // Move modal to body
      this.measurementInfoModalDialog?.show();
    }
  }

  toggleEditable() {
    if (this.isUpdating) return;
    this.isEditable = !this.isEditable;
  }

  updateProduct() {
    this.isUpdating = true;
    const dataForm = this.$refs.dataForm as typeof ElForm;
    dataForm?.validate(async (valid: any) => {
      if (!valid) return;
      const newName = this.productState.name + ' phase1';
      productService
        .updateProduct({
          productId: this.product.productId,
          name: newName,
          description: this.productState.description,
        })
        .then(() => {
          this.isUpdating = false;
          this.toggleEditable();
          this.$emit('productUpdated', {
            productId: this.product.productId,
            name: newName,
          });
        })
        .catch((err) => {
          this.isUpdating = false;
          console.error('[ERROR UPDATE PRODUCT]: ', err);
        });
    });
  }

  handleShowVideo(payload: TableField): void {
    const rendererDetails = this.$refs.previewRendererDetails as InstanceType<typeof PreviewRendererDetails>;

    if (!payload || !rendererDetails) return;
    console.log('payload', payload);

    const { filename, fileType, fileUrl } = payload;
    rendererDetails.handleShowModal({
      fileName: filename,
      fileType,
      fileUrl,
    });
  }
}
</script>

<style scoped lang="scss">
#product-parameter {
  background: transparent radial-gradient(closest-side at 50% 50%, rgba(75, 75, 75, 0.85) 0%, rgba(0, 0, 0, 0.85) 100%) 0% 0% no-repeat padding-box;
}

#measurement-info {
  .modal-content {
    display: flex;
    flex-direction: column;
    height: 80%;
    border-radius: 10px;
    border: none;
    overflow: hidden;
    background-color: #fff;
    padding-left: 2rem;
    padding-bottom: 3rem;
  }

  .modal-header {
    flex-shrink: 0;
    padding: 1rem;
    border-bottom: none;
    background-color: #fff;
    z-index: 2;
  }

  .modal-body {
    flex: 1;
    overflow: hidden;
    max-height: 25rem;
    background-color: #fff;
  }

  .txtcol {
    max-height: 20rem;
    overflow-y: scroll;
  }

  .infoimg {
    margin-left: 5rem;
    max-height: 20rem;
  }
}

#value1-range-text,
#value2-range-text,
#value1,
#value2 {
  margin-top: -0.65rem;
}

#value1,
#value2 {
  padding: 0.5rem;
}

.form-text {
  font-size: 1rem;
  font-weight: 600;
}

.subtitle {
  font-size: 1.3rem;
  font-weight: 600;
}

.el-form {
  width: 100%;
  i {
    width: auto;
    cursor: pointer;
    font-size: 16px;
  }
}
</style>
